import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./views/Index.vue')
    },
    // {
    //   path: '/list',
    //   name: 'list',
    //   component: () => import('./views/List.vue')
    // },
    // {
    //   path: '/page',
    //   name: 'page',
    //   component: () => import('./views/Page.vue')
    // },
    // {
    //   path: '/centent',
    //   name: 'centent',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Centent.vue')
    // },
    // {
    //   path: '/Search',
    //   name: 'Search',
    //   component: () => import(/* webpackChunkName: "about" */ './views/Search.vue')
    // },
  ]
})
